import React from 'react'
import styled from 'styled-components'
import colors from '../styles/colors'
import text from '../styles/text'
import media from '../styles/media'
import ContentWidth from "./ContentWidth"

const Col = ({ content, index }) => {
  return (
      <Container>
        {content.link ? (
            <LogoLink href={content.link} target="_blank" rel="noopener noreferrer">
              {content.icon ? (
                <LogoImage
                  alt={content?.icon?.altText}
                  src={content.icon.sourceUrl}
                  loading="eager"
                />
              ) : null}
            </LogoLink>
        ) : null}
        {content.icon && !content.link ? (
          <LogoImage
            alt={content?.icon?.altText}
            src={content.icon.localFile.childImageSharp.fluid}
            loading="eager"
          />
        ) : null}
        <Headline>{content.headline}</Headline>
        <BodyCopy dangerouslySetInnerHTML={{ __html: content.bodyCopy }} />
      </Container>
  )
}


const PartnerStatic = ({ content }) => {
  return (
    <ContentWidth>
      <TextContainer>
        <PartnerHeadline>{content.headline}</PartnerHeadline>
        <BodyCopy dangerouslySetInnerHTML={{ __html: content.bodyCopy }} />
      </TextContainer>
      <LogoContainer>
        <LogoColumn>
          {content.columns.map((col, index) => (
            <Col key={index} index={index} content={col} />
          ))}
        </LogoColumn>
      </LogoContainer>
            <LogoLink
              href={content.ctaLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              {content.ctaText}
            </LogoLink>
    </ContentWidth>
  )
}

const TextContainer = styled.div`
    margin: auto;
    text-align: center;
    padding: 8px;
`
const PartnerHeadline= styled.h4`
    color: ${colors.gray800};
    ${text.h4};
`
const LogoContainer = styled.div`
    width: 100%;
    margin: auto;

    ${media.tablet} {
      position: relative;
      left: 2vw;
    }
`
const LogoColumn = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    text-align: left;
    margin: 12px 0px;
    justify-items: center;
`
const Container = styled.div`
    width: 100%;
    margin: 24px;
    flex-basis: 20%;
    text-align: left;
    margin: auto;
`
const LogoLink = styled.a`
`
const LogoImage = styled.img`
    filter: grayscale(100%);
    width: 125px;
`
const Headline = styled.h5`
    ${text.h5}

    ${media.mobile} {
      ${text.h4};
    }
`
const BodyCopy = styled.div`
`

export default PartnerStatic
